import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'startCode',
        title: 'Başlangıç Abone Kodu',
        rules: {required: true},
        modal: ['begin_account_code'],
        data: ['begin_account_code'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'count',
        title: 'Rezerve Edilecek Abone Adeti',
        rules: {required: true, numeric: true},
        modal: ['count'],
        data: ['count'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'prefix',
        title: 'Ön Ek',
        rules: {required: false},
        modal: ['prefix'],
        data: ['prefix'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'hex',
        title: 'Abone Kodunda Hex Kullan',
        default:false,
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {text: i18n.t('general.yes'), value: true},
                {text: i18n.t('general.no'), value: false},
            ],
        },
        modal: ['use_hex'],
        data: ['use_hex'],
        additionalButton: false,
        checkBox: false
    }
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/reserveForm.js